import React from 'react';
import {
  Container,
  Navbar,
  NavbarBrand,
  NavItem,
  NavLink,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import fireIcon from '../images/fire.svg';
import logoutIcon from '../images/logout.png';
import * as AppConstants from '../AppConstants';
import { useEffect } from 'react';
import moment from 'moment';

export const NavMenu = () => {
  const logout = (e) => {
    e.preventDefault();

    //Destroy session info
    localStorage.clear();

    //Reload window, Routing will handle redirect
    window.location.reload();
  };

  // Define a function that shows an alert
  const logutInactivity = () => {
    let lastInteraction = moment(localStorage.getItem('lastInteraction')); //Last user interaction datetime
    let timeDiff = moment().diff(lastInteraction, 'minutes'); //Difference between last interaction and current datetime
    if (timeDiff > 60) {
      //Logout due to inactivity
      logout(new Event('click'));
    } else {
      //Update last interaction
      localStorage.setItem('lastInteraction', moment());
    }
  };

  // Use useEffect to add an event listener to the window object
  useEffect(() => {
    // Add the event listener on mount
    window.addEventListener('click', logutInactivity);

    // Remove the event listener on unmount
    return () => {
      window.removeEventListener('click', logutInactivity);
    };
  }, []); // Pass an empty dependency array to run only once

  return (
    <header>
      <Navbar
        className="navbar ng-white border-bottom box-shadow mb-3"
        light
      >
        <Container fluid={false}>
          <div className="d-flex justify-content-between align-items-center w-100">
            <NavbarBrand tag={Link} to="/home">
              <img
                src={AppConstants.BASE_URL_FILE + 'AppShell/squarelogo.png'}
                alt="Logo"
                width={64}
                height={64}
                style={{ objectFit: 'contain' }}
              />
            </NavbarBrand>
            <div className="d-flex flex-row">
              <ul className="navbar-nav flex-grow d-flex flex-row justify-content-center align-items-center ">
                <NavItem>
                  Welcome,{' '}
                  {localStorage.getItem('username')?.toUpperCase()}
                  &nbsp; &nbsp;
                </NavItem>
                <NavItem>
                  <NavLink
                    tag={Link}
                    className="text-dark"
                    to="/HotProperties"
                  >
                    <img
                      className="mr-2"
                      src={fireIcon}
                      alt="Hot Properties"
                      title="Hot Properties"
                      style={{ width: '40px', height: '38px' }}
                    ></img>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    tag={Link}
                    className="text-dark"
                    to="/Favourites"
                  >
                    <i
                      className="far fa-heart fa-2x mr-3"
                      aria-hidden="true"
                      title="Favourite Properties"
                    ></i>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink tag={Link} className="text-dark" to="#">
                    <img
                      className="mr-2"
                      src={logoutIcon}
                      alt="Logout"
                      title="Logout"
                      style={{ width: '34px', height: '32px' }}
                      onClick={(e) => {
                        logout(e);
                      }}
                    ></img>
                  </NavLink>
                </NavItem>
              </ul>
            </div>
          </div>
        </Container>
      </Navbar>
    </header>
  );
};
